// @ts-nocheck
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Observable, Observer, Subscription } from 'rxjs';
import { share } from 'rxjs/operators';
import svgIconList from '../../../../public/assets/icons.json';
import { USPSectionHttpService } from '@core/services/usp-section-http.service';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { IsLoggedIn } from '@core/entity/auth/state/auth.selectors';
import { GameCategoryDataService } from '@core/services/games/gamecategory-data.service';
import { LogoFaviconHttpService } from '@core/services/logo-favicon-http.service';
import { DomainService } from '@core/services/domain.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PlatformService } from '@core/services/platform.service';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

declare const $: any;
type CountryEntry = { name: string; languages: string[]; [k: string]: any };
type CountryMap = { [country: string]: CountryEntry };
type DomainMap = { [domain: string]: CountryMap };
type LanguageMap = { [code: string]: string };
@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, SafeHtmlPipe],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})

export class LandingComponent implements OnInit, OnDestroy {
  siteName = environment.siteName;
  projectCode = environment.projectCode.toLowerCase();
  local: any;
  availableCountryAndLanguages: DomainMap = {};
  currentCountryCode: any;
  currentLanguageCode: any;
  languages: LanguageMap = {};
  currentDomain: string;
  isQP17b = this.projectCode === 'qp17b';
  isQP22 = this.projectCode === 'qp22';
  isQP23 = this.projectCode === 'qp23';

  isLoggedIn = false;

  promotions = ['10-reload-bonus', '100-welcome-bonus-slots', 'slots_unlimited_cash_rebate'];
  isCarouselRendered = false;
  whyUs = [
    { code: '24x7', text: '24x7 Premium Support' },
    { code: 'worry-free', text: 'Worry-Free Experience' },
    { code: 'widest-choice', text: 'Widest Choice of Latest Games' },
    { code: 'fast-deposits', text: 'Fast Deposits & Payouts' },
    { code: 'attractive-promos', text: 'Attractive Promotions & Rewards' },
  ]
  activeTab = this.whyUs[0].code;
  vendors = {
    casino: ['ag', 'bg', 'ab', 'sexy', 'wm', 'dg', 'evo', 'ebet', 'mg', 'sa', 'pp', 'pt'],
    slots: ['pp', 'pt', 'haba', 'kiss', 'mega', 'jk', 'sg', 'cq9', 'live', 'next', 'net', 'png'],
    sports: ['max', 'cmd', 'sbo'],
    fishing: ['live', 'bg', 'sg', 'cq9', 'yl', 'pp', 'jk'],
    esports: ['max', 'cmd', 'im']
  }
  activeCategory = 'casino';
  config = {
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    value: 3004223.12,
    auto: true,
  }
  number: number = 3004223.12;
  observable: Observable<boolean>;
  observer: Observer<boolean>;
  timer1: any;
  timer2: any;
  windowScrolled: boolean = false;

  marketingCampaign: any;

  svg: any = svgIconList;
  logoUrl : any = '';

  usps: any = [];
  uspLength = 0;
  isSkeletonUsps = true;
  isSkeletonGameCategory = true;
  uspMainContent: any;
  categorylocales: any = [];
  availableProvider: any = {};
  private subscriptions = new Subscription();

  constructor(
    private dropdownHttpService: DropdownHttpService,
    private cdr: ChangeDetectorRef,
    private uspSectionHttpService: USPSectionHttpService,
    private store: Store<AppState>,
    private gameCategoryDataService: GameCategoryDataService,
    private logoFaviconHttpService: LogoFaviconHttpService,
    private domainService: DomainService,
    private deviceDetectorService: DeviceDetectorService,
    private platformService: PlatformService,
    private translateService: TranslateService,
  ) {
    // Move field initializers that reference DI'd services into the constructor (Angular 19 field-init order)
    this.availableCountryAndLanguages = this.dropdownHttpService.availableCountryAndLanguages;
    this.languages = this.dropdownHttpService.languages;
    // Browser-only state from localStorage
    if (this.platformService.isBrowser()) {
      this.local = localStorage;
      const storedLocale = localStorage.getItem('locale');
      if (storedLocale?.includes('-')) {
        this.currentLanguageCode = storedLocale.split('-')[0].toUpperCase();
        this.currentCountryCode = storedLocale.split('-')[1].toUpperCase();
        this.translateService.use(this.currentLanguageCode.toLowerCase());
      }
      this.marketingCampaign = localStorage.getItem('marketing_campaign');
      const ap = localStorage.getItem('available_providers');
      this.availableProvider = ap ? JSON.parse(ap) : {};
    }

    this.observable = new Observable<boolean>((observer: any) => this.observer = observer).pipe(share());
    if (this.platformService.isBrowser()) {
      setInterval(() => {
        this.number += 60.13;
      }, 5000);
      this.onTabCycle();      // jQuery
      this.onCategoryTabs();  // jQuery
    }
  }

  ngOnInit() {
    this.logoFaviconHttpService.desktop_logo$.subscribe((result) => { this.logoUrl = result; });

    if (this.platformService.isBrowser()) {
      const host = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');
      if (host === environment.altDomainName) {
        this.currentDomain = environment.altDomainName;
      } else if (host === environment.altDomainNameTwo) {
        this.currentDomain = environment.altDomainNameTwo;
      } else {
        this.currentDomain = environment.domainName;
      }
      this.renderCarousel(); // jQuery
    } else {
      this.currentDomain = environment.domainName;
    }
    this.getUsp();
    this.getAllcategorylocale();
    this.getAvailableProviders();
    this.store.pipe(select(IsLoggedIn)).subscribe(value => this.isLoggedIn = value);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    if (this.platformService.isBrowser()) {
      this.onStopCycle();         // window.clearInterval
      this.onStopCategoryTabs();  // window.clearInterval
    }
  }

  setLanguage(languageCode: string, countryCode: string) {
    localStorage.removeItem('announcements_pop');

    if (this.currentLanguageCode != languageCode || this.currentCountryCode != countryCode) {
      sessionStorage.removeItem('logo_favicon');
    }

    localStorage.setItem('locale', `${languageCode}-${countryCode}`.toLowerCase());

    const locale = `${languageCode}-${countryCode}`.toLowerCase();
    const hostname = this.getRedirectHostname(countryCode);

    // Marketing campaign params (if any) go as normal query string on the new URL.
    let queryString = '';
    if (this.marketingCampaign != null) {
      const marketingCampaignObject = JSON.parse(this.marketingCampaign);
      const params: string[] = [];
      Object.keys(marketingCampaignObject).forEach(key => {
        // AIO-76147: 'campaign'/'dialog' are hidden from the address bar, so they
        // must not be put back here either - they stay in marketing_campaign.
        if (['lang', 'campaign', 'dialog'].includes(key)) return;
        params.push(`${encodeURIComponent(key)}=${encodeURIComponent(marketingCampaignObject[key])}`);
      });
      if (params.length) queryString = '?' + params.join('&');
    }

    const url = (environment.https ? 'https://' : '//') + hostname;
    window.location.assign(url + '/' + locale + '/home' + queryString);
  }

  private getRedirectHostname(countryCode: string): string {
    const currentHostname = (window.location.hostname).replace(/^([w]{3}.)(?=[a-z0-9]+)/, '');
    const currentHostWithPort = `${currentHostname}${window.location.port ? ':' + window.location.port : ''}`;
    const dynamicDomainSet = this.domainService.getDomainSet();
    const dynamicCountrySet = dynamicDomainSet?.[this.currentDomain]?.[countryCode.toLowerCase()];
    const dynamicBase = this.domainService.getRedirectBaseFromDynamicCountryCfg(
      dynamicCountrySet,
      environment.domainEnv,
      currentHostname,
      window.location.pathname || '/'
    );

    const fallbackCountrySet = this.availableCountryAndLanguages?.[this.currentDomain]?.[countryCode.toUpperCase()];
    const fallbackBase = fallbackCountrySet?.[environment.domainEnv]?.[0] || '';
    const fallbackHostname = fallbackBase ? fallbackBase : null;
    if (dynamicBase) {
      return (dynamicBase || '').toString().trim().toLowerCase();
    }
    if (fallbackHostname) {
      return (fallbackHostname || '').toString().trim().toLowerCase();
    }

    return currentHostWithPort;
  }

  onTabCycle() {
    this.timer1 = setInterval(() => {
      this.onChangeTab();
    }, 8000);
  }

  onStopCycle() {
    window.clearInterval(this.timer1);
  }

  onChangeTab() {
    var $tabStacked = $(".cycle-tab li.selected-whyus");
    if ($tabStacked.is(".cycle-tab li:last-child")) {
      $tabStacked.removeClass("selected-whyus");
      $(".cycle-tab li:first").addClass("selected-whyus");
      this.onSelectTab('24x7');
    } else {
      $tabStacked.removeClass("active selected-whyus").next().addClass("active selected-whyus");
      this.onSelectTab($tabStacked.next().attr('id'));
    }
    this.cdr.detectChanges()
  }

  onSelectTab(item: any, click?: boolean) {
    if (click) {
      this.onStopCycle();
      setTimeout(() => {
        this.onTabCycle();
      });
    }
    this.activeTab = item;
  }

  // FEATURED PROMOTIONS CAROUSEL
  renderCarousel() {
    this.isCarouselRendered = true;
    this.cdr.detectChanges();
    $(document).find('ul#carousel1').carouselSlider({
      carouselOptions: {
        autoplay: true,
        autoplayInitialDelay: 1000,
        autoplayDuration: 5000,
        autoplayPauseOnHover: true,
        clickToFocus: true,
        btnPrev: '.prevArrow',
        btnNext: '.nextArrow',
        duration: 400,
        minScale: 0.4,
        // enableDrag: true
      },
      arrowAutoHide: false,
      animateStyle: 'twirl',
      triggerBy: 'click',
      clickIcons: true
    });
  }

  onSliderButton(event: any) {
    if (event.deltaX > 0) {
      $(document).find('.prevArrow').click();
    } else {
      $(document).find('.nextArrow').click();
    }
  }

  onCategoryTabs() {
    this.timer2 = setInterval(() => {
      this.onChangeCategory();
    }, 8000);
  }

  onStopCategoryTabs() {
    window.clearInterval(this.timer2);
  }

  onChangeCategory() {
    var $navStacked = $(".game-category li.selected");
    if ($navStacked.is(".game-category li:last-child")) {
      $navStacked.removeClass("selected");
      $(".game-category li:first").addClass("selected");
      this.onSelectCategory('casino');
    } else {
      $navStacked.removeClass("active selected").next().addClass("active selected");
      this.onSelectCategory($navStacked.next().attr('id'));
    }
    this.cdr.detectChanges();
  };

  getUsp(){
    this.uspSectionHttpService.getAll().subscribe(res =>{
      this.usps = res.contents.rows;
      this.uspMainContent = res.main_descriptions[0] ? res.main_descriptions[0] : null;

      this.isSkeletonUsps = false;
    });
  }

  onSelectCategory(item: any, click?: boolean) {
    if (click) {
      this.onStopCategoryTabs();
      setTimeout(() => {
        this.onCategoryTabs();
      });
    }
    this.activeCategory = item;
  }

  getCurrentYear() {
    return new Date().getFullYear()
  }

  returnZero() {
    return 0;
  }

  onScrollTop() {
    if (window && window.pageYOffset) {
      window.scroll(0, 0);
    }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    }
    else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
      this.windowScrolled = false;
    }
  }

  getAllcategorylocale(){
    this.gameCategoryDataService.getAllcategorylocale().subscribe(res =>{
      if(this.isQP17b) {
        const wantedList = ['LC', 'SL', 'FS', 'SP', 'ES'];
        res = res
          .filter(item => wantedList.includes(item.code))
          .sort((a, b) => {
            return wantedList.indexOf(a.code) - wantedList.indexOf(b.code);
        });
      }
      this.categorylocales = res;
      // console.log('categorylocales', this.categorylocales);
      this.isSkeletonGameCategory = false;
    });
  }

  getAvailableProviders() {
    this.subscriptions.add(
      this.gameCategoryDataService.availableProviders$.subscribe(providers => {
        if (providers) {
          this.availableProvider = providers;
          this.cdr.detectChanges();
        }
      })
    );
  }
}